module.exports = __webpack_public_path__ + "static/media/help_register_personal.ef097df8.jpg";